import { render, staticRenderFns } from "./SamGoodsPriceRecordDialog.vue?vue&type=template&id=001356d3"
import script from "./SamGoodsPriceRecordDialog.vue?vue&type=script&lang=js"
export * from "./SamGoodsPriceRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./SamGoodsPriceRecordDialog.vue?vue&type=style&index=0&id=001356d3&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('001356d3')) {
      api.createRecord('001356d3', component.options)
    } else {
      api.reload('001356d3', component.options)
    }
    module.hot.accept("./SamGoodsPriceRecordDialog.vue?vue&type=template&id=001356d3", function () {
      api.rerender('001356d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/samSkuList/components/SamGoodsPriceRecordDialog.vue"
export default component.exports